/* Sole Sox: route every theme "open cart" call to the Unicorn Boost cart drawer.
   Lives in its own file (loaded by sections/ss-custom-code.liquid) so Be Yours theme updates
   don't overwrite it. The theme drawer is only used if Unicorn never loads. */
(function () {
  // Opens the Unicorn cart drawer, waiting briefly if the app script hasn't loaded yet.
  // Resolves false when Unicorn isn't available so callers can fall back.
  window.ssOpenCart = function () {
    const openUnicorn = async () => {
      if (typeof window.unicornRefreshCart === 'function') { try { await window.unicornRefreshCart(); } catch (e) { /* ignore */ } }
      window.unicornOpenCart();
      return true;
    };
    if (typeof window.unicornOpenCart === 'function') return openUnicorn();
    return new Promise((resolve) => {
      let waited = 0;
      const timer = setInterval(() => {
        waited += 200;
        if (typeof window.unicornOpenCart === 'function') { clearInterval(timer); resolve(openUnicorn()); }
        else if (waited >= 5000) { clearInterval(timer); resolve(false); }
      }, 200);
    });
  };

  // The theme's <mini-cart>.open() is called by quick add, swatches, the mobile dock and
  // renderContents(); send those to Unicorn instead of the theme drawer.
  customElements.whenDefined('mini-cart').then(() => {
    const MiniCart = customElements.get('mini-cart');
    if (!MiniCart || MiniCart.prototype.ssPatched) return;
    const nativeOpen = MiniCart.prototype.open;
    MiniCart.prototype.open = function () {
      window.ssOpenCart().then((opened) => { if (!opened) nativeOpen.call(this); });
    };
    MiniCart.prototype.ssPatched = true;
  });
})();
